import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

export default function PaymentSuccess() {
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  
  const paymentId = state?.paymentId || 'N/A';
  const orderId = state?.orderId || 'N/A';
  const amount = state?.amount || 0;

  if (!state) {
    navigate('/cart');
    return null;
  }

  return (
    <div className="min-h-screen bg-[#fffaf3] py-12">
      <div className="max-w-2xl mx-auto px-6">
        <div className="bg-white rounded-lg shadow-lg p-8 text-center">
          <div className="mb-6">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-2xl">✅</span>
            </div>
            <h1 className="text-3xl font-serif font-light text-[#2f2a1e] mb-2">
              Paiement Réussi !
            </h1>
            <p className="text-[#7a7250]">
              Merci pour votre achat. Votre commande a été traitée avec succès.
            </p>
          </div>
          
          <div className="bg-gray-50 rounded-lg p-6 mb-8">
            <h3 className="font-semibold text-[#2f2a1e] mb-4">Détails de la commande</h3>
            <div className="space-y-2 text-left max-w-xs mx-auto">
              <div className="flex justify-between">
                <span className="text-[#7a7250]">Référence:</span>
                <strong className="text-[#2f2a1e]">{orderId}</strong>
              </div>
              <div className="flex justify-between">
                <span className="text-[#7a7250]">ID Paiement:</span>
                <strong className="text-[#2f2a1e]">{paymentId}</strong>
              </div>
              <div className="flex justify-between">
                <span className="text-[#7a7250]">Montant:</span>
                <strong className="text-[#2f2a1e]">{amount.toFixed(2)} MAD</strong>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/shop" 
              className="bg-[#2f2a1e] text-white px-6 py-3 rounded-lg hover:bg-[#d0b125] transition font-light"
            >
              Continuer mes achats
            </Link>
            <Link 
              to="/orders" 
              className="border border-[#2f2a1e] text-[#2f2a1e] px-6 py-3 rounded-lg hover:bg-[#2f2a1e] hover:text-white transition font-light"
            >
              Voir mes commandes
            </Link>
          </div>

          <div className="mt-8 p-4 bg-[#fffaf3] border border-[#d0b125]/30 rounded-lg">
            <p className="text-sm text-[#7a7250]">
              Un email de confirmation vous a été envoyé avec les détails de votre commande.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}